var config = {
  test: Math.random().toString()
};
export var setConfig = function setConfig(newConfig) {
  Object.keys(newConfig).forEach(function (key) {
    config[key] = newConfig[key];
  });
};
export var getEnv = function getEnv(key) {
  return config[key];
};
//# sourceMappingURL=config.js.map